'use client';

import { PropsWithChildren, Suspense, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SiteProvider } from '@/shared/providers/site';
import { Toaster } from '@/shared/shadcn/ui/sonner';
import { DialogProvider } from './dialog';
import { ThemeProvider } from 'next-themes';

export function Providers({ children }: PropsWithChildren) {
  const [client] = useState(
    new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
        },
      },
    }),
  );

  return (
    <QueryClientProvider client={client}>
      <ThemeProvider attribute="class" defaultTheme="light">
        <SiteProvider>
          <Suspense>
            <DialogProvider>
              <Toaster position="top-center" />
              {children}
            </DialogProvider>
          </Suspense>
        </SiteProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
